import {ConditionalFieldDefinition} from "../conditionalRules/conditionalFieldDefinition";
import {VisualizationDataPointCapability} from "~/models/visualizations/VisualizationDataPointCapability";

export enum VisualizationDataPointConditionalFieldType {
  visualization = 1,
}

export interface VisualizationConditionalField extends  ConditionalFieldDefinition{
  type: VisualizationDataPointConditionalFieldType.visualization;
  capability?: VisualizationDataPointCapability;
}

// Defines the conditional fields that reference object model properties.
export default class VisualizationDataPointConditionalFields {
  static VISUALIZATION_FILTER: VisualizationConditionalField = {
    type: VisualizationDataPointConditionalFieldType.visualization,
    capability: VisualizationDataPointCapability.filterable,
    fieldName: 'data_point',
    defaultConditionalValue: true,
    friendlyName: (r) => r.conditional_value
  };
  static VISUALIZATION_FIELDS: VisualizationConditionalField[] = [
    VisualizationDataPointConditionalFields.VISUALIZATION_FILTER,
  ];
}